import { formatInTimeZone } from 'date-fns-tz';

import type { ButtonPressWithId } from '@/hooks/useButtonPresses';

interface Props {
  presses: ButtonPressWithId[];
  tz: string;
}

export function ButtonPressList({ presses, tz }: Props) {
  if (presses.length === 0) {
    return (
      <p className="text-sm text-ink-soft">No button presses on this day.</p>
    );
  }
  return (
    <ul className="divide-y divide-paper-border">
      {presses.map((p) => (
        <li key={p.id} className="flex items-baseline justify-between py-2">
          <span className="font-medium text-ink">
            {formatInTimeZone(p.pressedAt.toDate(), tz, 'HH:mm')}
          </span>
          <span className="text-sm text-ink-soft">
            {p.roomLabel || 'Button'}
          </span>
        </li>
      ))}
    </ul>
  );
}
